import type { ExtendedInitiative } from '../../../../../api/initiative-client/initiative-client.type';
import type { ProjectsResponse } from '../../../../../api/projects-client/projects-client.type';
import i18n from '../../../../../base-dictionary';
import { getHealthScoreGrade } from '../../../../../helpers/project-metrics-helper/project-metrics-helper';
import { formatInitiativeDate } from '../../../strategy-v2.helpers';

/**
 * Get team information to display in the side section
 *
 * @param {ProjectsResponse} team - The team to get information for
 * @param {ExtendedInitiative | null} initiative - The initiative that the team belongs to
 * @returns {Array<{label: string, value: string | number | null | undefined}>} An array of label-value pairs with team information
 */
const getTeamInfo = (
  team: ProjectsResponse,
  initiative: ExtendedInitiative | null,
): { label: string; value: string | number | null | undefined }[] => {
  const initialContribution = initiative?.initial_contributions?.team[team.id];

  return [
    {
      label: i18n.t('strategy.initiative_performance.performance_score_current', 'Performance Score (Current)'),
      value: getHealthScoreGrade(team.health),
    },
    {
      label: i18n.t('strategy.initiative_performance.project_manager', 'PM'),
      value: team.pm,
    },
    {
      label: i18n.t('strategy.initiative_performance.cost_to_date_initiative', 'Cost to Date (This Initiative)'),
      value: initiative?.costs_to_date?.teams[team.id] ?? i18n.t('strategy.initiatives.labels.no_data', '-'),
    },
    {
      label: i18n.t('strategy.initiative_performance.start_date_first_task', 'Start Date (First Task)'),
      value: initialContribution
        ? formatInitiativeDate(initialContribution)
        : i18n.t('strategy.initiatives.labels.no_data', '-'),
    },
    {
      label: i18n.t('strategy.initiative_performance.task_count_initiative', 'Task Count (This Initiative)'),
      value: team.task_count,
    },
  ];
};

export { getTeamInfo };
